export enum TipoAvisoVencimentoEnum {
    NaoAvisar = 1,
    NoDia = 2,
    UmDiaAntes = 3,
    DoisDiasAntes = 4,
    CincoDiasAntes = 5,
    SeteDiasAntes = 6
}
